export default {
  BASE_URL: 'psm/msg',
  api: [
      {
          name: 'query',
          desc: '获取消息',
          method: 'GET',
          path: '/query'
      },
      {
          name: 'list',
          desc: '消息列表',
          method: 'GET',
          path: '/list',
      },
      {
          name: 'delete',
          desc: '删除消息',
          method: 'POST',
          path: '/delete'
      },
      {
          name: 'create',
          desc: '创建消息',
          method: 'POST',
          path: '/create'
      },
  ]
}


// WEBPACK FOOTER //
// ./src/api/psm/qc/msg.js